import { DIGITAL_PRODUCT_API } from 'modules/digital-product/api'
import { digitalProductRevalidationKeys } from 'modules/digital-product/constants/digital-product-dependencies'
import { DigitalProductId } from 'modules/digital-product/types/digital-product-interface'

export const getDigitalProductSwrKey = (id: DigitalProductId) => [
  `${DIGITAL_PRODUCT_API}/${id}`,
  ...digitalProductRevalidationKeys,
]
